/* I LOVE DUFT — Fragrance Finder
   Client-side scoring against product metafields, luxury multi-step flow,
   3 curated results + Ask-Beat-on-WhatsApp lead capture. */
(function () {
  'use strict';

  function initFinder(root) {
    if (!root || root.dataset.ffInit === '1') return;
    root.dataset.ffInit = '1';

    var steps = Array.prototype.slice.call(root.querySelectorAll('.ff__step'));
    var progressBar = root.querySelector('.ff__progress-bar');
    var loading = root.querySelector('.ff__loading');
    var results = root.querySelector('.ff__results');
    var quiz = root.querySelector('.ff__quiz');
    var resultsGrid = root.querySelector('.ff__results-grid');
    var waBtn = root.querySelector('.ff__wa-btn');
    var restartBtn = root.querySelector('.ff__restart');
    var total = steps.length;
    var current = 0;

    var answers = { gender: null, mood: null, notes: [], occasion: [], strength: 'moderate' };
    var strengthMap = ['light', 'moderate', 'strong', 'beast'];

    /* ---- collect candidate products from hidden DOM ---- */
    var candidates = Array.prototype.slice.call(root.querySelectorAll('.ff-candidate')).map(function (el) {
      return {
        el: el.querySelector('.ild-card'),
        gender: split(el.dataset.gender),
        mood: split(el.dataset.mood),
        notes: split(el.dataset.notes),
        occasion: split(el.dataset.occasion),
        strength: (el.dataset.strength || '').trim().toLowerCase(),
        title: el.dataset.title || ''
      };
    }).filter(function (c) { return c.el; });

    function split(v) {
      if (!v) return [];
      return v.split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    }

    var startScreen = root.querySelector('.ff__start');
    var main = root.querySelector('.ff__main');

    /* ---- step navigation ---- */
    function showStep(i, noScroll) {
      current = Math.max(0, Math.min(i, total - 1));
      steps.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
      if (progressBar) progressBar.style.width = ((current + 1) / total) * 100 + '%';
      updateNav();
      if (!noScroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function startQuiz() {
      if (startScreen) startScreen.style.display = 'none';
      if (main) main.classList.remove('is-hidden');
      showStep(0);
    }

    function updateNav() {
      var step = steps[current];
      var next = step.querySelector('[data-ff-next]');
      if (!next) return;
      var type = step.dataset.ffType;
      var ok = true;
      if (type === 'single') ok = !!step.querySelector('.is-selected');
      if (type === 'multi') ok = !!step.querySelector('.is-selected');
      next.disabled = !ok;
    }

    /* ---- option handlers ---- */
    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-ff-value]');
      if (opt && root.contains(opt)) {
        var step = opt.closest('.ff__step');
        var field = step.dataset.ffField;
        var type = step.dataset.ffType;
        var value = opt.dataset.ffValue;

        if (type === 'single') {
          step.querySelectorAll('[data-ff-value]').forEach(function (o) { o.classList.remove('is-selected'); });
          opt.classList.add('is-selected');
          answers[field] = value;
          updateNav();
          // auto-advance for single-choice card steps after a short beat
          if (step.dataset.ffAuto === '1') {
            setTimeout(function () { goNext(); }, 260);
          }
        } else if (type === 'multi') {
          opt.classList.toggle('is-selected');
          var arr = [];
          step.querySelectorAll('[data-ff-value].is-selected').forEach(function (o) { arr.push(o.dataset.ffValue); });
          answers[field] = arr;
          updateNav();
        }
        return;
      }

      if (e.target.closest('[data-ff-start]')) { e.preventDefault(); startQuiz(); return; }
      if (e.target.closest('[data-ff-next]')) { e.preventDefault(); goNext(); return; }
      if (e.target.closest('[data-ff-prev]')) { e.preventDefault(); showStep(current - 1); return; }
      if (e.target.closest('[data-ff-restart]')) { e.preventDefault(); restart(); return; }
    });

    /* ---- strength slider ---- */
    var slider = root.querySelector('.ff__slider');
    if (slider) {
      var sliderLabels = Array.prototype.slice.call(root.querySelectorAll('.ff__slider-labels span'));
      var syncSlider = function () {
        var idx = parseInt(slider.value, 10) || 0;
        answers.strength = strengthMap[idx];
        sliderLabels.forEach(function (l, i) { l.classList.toggle('is-active', i === idx); });
      };
      slider.addEventListener('input', syncSlider);
      syncSlider();
    }

    function goNext() {
      if (current < total - 1) { showStep(current + 1); }
      else { finish(); }
    }

    /* ---- scoring ---- */
    function scoreProduct(p) {
      var score = 0;
      // mood (single) up to 20
      if (answers.mood && p.mood.indexOf(answers.mood) !== -1) score += 20;
      // notes (multi) up to 40, proportional
      if (answers.notes.length) {
        var matchedNotes = answers.notes.filter(function (n) { return p.notes.indexOf(n) !== -1; }).length;
        score += (matchedNotes / answers.notes.length) * 40;
      }
      // occasion (multi) up to 20
      if (answers.occasion.length) {
        var matchedOcc = answers.occasion.filter(function (o) { return p.occasion.indexOf(o) !== -1; }).length;
        score += (matchedOcc / answers.occasion.length) * 20;
      }
      // strength (single) up to 20
      if (answers.strength && p.strength === answers.strength) score += 20;
      return score;
    }

    function genderMatches(p) {
      if (!answers.gender) return true;
      if (!p.gender.length) return true; // untagged products stay eligible
      return p.gender.indexOf(answers.gender) !== -1 || p.gender.indexOf('unisex') !== -1;
    }

    function finish() {
      steps.forEach(function (s) { s.classList.remove('is-active'); });
      if (quiz) quiz.style.display = 'none';
      if (progressBar) progressBar.style.width = '100%';
      if (loading) loading.classList.add('is-active');

      setTimeout(renderResults, 2000);
    }

    function renderResults() {
      if (loading) loading.classList.remove('is-active');

      var pool = candidates.filter(genderMatches);
      if (!pool.length) pool = candidates.slice();

      var scored = pool.map(function (p) { return { p: p, score: scoreProduct(p) }; })
        .sort(function (a, b) { return b.score - a.score; });

      resultsGrid.innerHTML = '';

      if (!scored.length) {
        resultsGrid.innerHTML = '<p class="ff__empty">No fragrances are available to match yet. Please ask Beat directly.</p>';
      } else {
        var ranks = ['Beat’s Recommendation', 'Alternative Pick', 'Unexpected Match'];
        var picks = [];
        picks.push(scored[0]);
        if (scored[1]) picks.push(scored[1]);
        // unexpected: a lower-ranked but still-valid option for a delightful surprise
        if (scored.length > 3) picks.push(scored[Math.min(4, scored.length - 1)]);
        else if (scored[2]) picks.push(scored[2]);

        var maxScore = scored[0].score || 1;
        picks.forEach(function (item, i) {
          var pct = Math.round(40 + (item.score / 100) * 60); // present a flattering 40-100% range
          if (item.score === 0) pct = 60;
          var wrap = document.createElement('div');
          wrap.className = 'ff__result';
          var head = document.createElement('div');
          head.className = 'ff__result-head';
          head.innerHTML = '<span class="ff__result-rank">' + ranks[i] + '</span>' +
            '<span class="ff__result-match">' + pct + '% Match</span>';
          wrap.appendChild(head);
          wrap.appendChild(item.p.el); // move the premium card node into the result
          var why = document.createElement('p');
          why.className = 'ff__result-why';
          why.textContent = buildWhy();
          wrap.appendChild(why);
          resultsGrid.appendChild(wrap);
        });
      }

      if (waBtn) waBtn.setAttribute('href', buildWaHref());
      if (results) results.classList.add('is-active');
      // refresh wishlist heart states for moved cards
      if (window.ILDWishlist && window.ILDWishlist.refresh) window.ILDWishlist.refresh();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function titleCase(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : ''; }

    function buildWhy() {
      var bits = [];
      if (answers.notes.length) bits.push('your love of ' + answers.notes.slice(0, 2).map(titleCase).join(' & ').toLowerCase() + ' notes');
      if (answers.mood) bits.push('a ' + answers.mood.toLowerCase() + ' character');
      if (answers.occasion.length) bits.push(answers.occasion[0].toLowerCase() + ' wear');
      if (!bits.length) return 'Hand-selected to suit your profile.';
      return 'Based on ' + bits.join(', ') + '.';
    }

    function buildWaHref() {
      var num = root.dataset.waNumber || '';
      var lines = [];
      lines.push('Hi Beat,');
      lines.push('');
      lines.push('I completed the fragrance finder. My profile:');
      lines.push('Gender: ' + (titleCase(answers.gender) || '—'));
      lines.push('Mood: ' + (titleCase(answers.mood) || '—'));
      lines.push('Notes: ' + (answers.notes.map(titleCase).join(', ') || '—'));
      lines.push('Occasion: ' + (answers.occasion.map(titleCase).join(', ') || '—'));
      lines.push('Strength: ' + titleCase(answers.strength));
      lines.push('');
      lines.push('Can you recommend the best fragrance for me?');
      var msg = encodeURIComponent(lines.join('\n'));
      return 'https://wa.me/' + num + (num ? '?text=' + msg : '');
    }

    function restart() {
      answers = { gender: null, mood: null, notes: [], occasion: [], strength: 'moderate' };
      root.querySelectorAll('[data-ff-value].is-selected').forEach(function (o) { o.classList.remove('is-selected'); });
      if (slider) { slider.value = 1; slider.dispatchEvent(new Event('input')); }
      if (results) results.classList.remove('is-active');
      if (quiz) quiz.style.display = '';
      showStep(0, true);
    }

    showStep(0, true);
  }

  function initAll() {
    document.querySelectorAll('.ff[data-ff-root]').forEach(initFinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
